export default __webpack_public_path__ + "static/media/WeerwoodTree.b0ee2a02.png";